export default "__VITE_ASSET__a9513239__"